export const getSubOrFullDomain = () =>
  window.location.hostname.match(/.*financetech(demo|test|365).com/g)
    ? window.location.hostname.split('.')[0]
    : window.location.hostname;

export const getSubdomain = () =>
  process.env.REACT_APP_SUBDOMAIN || getSubOrFullDomain();

export const getWhitelabelShortName = () => {
  const subdomain = getSubdomain();
  const domainSplit = subdomain?.split('-');

  if (domainSplit?.length > 0) {
    return domainSplit[domainSplit.length - 1];
  }
};

export const isImg = (path) =>
  path?.match(/\.(jpe?g|webp|gif|png|svg|bmp)(\?d=([0-9]+)x([0-9]+))?$/i) !=
  null;

export default {
  getSubOrFullDomain,
  getSubdomain,
  getWhitelabelShortName,
  isImg,
};
